import { EmblaOptionsType } from 'embla-carousel';
import React, { useEffect, useState } from 'react';

import { useSiteContext } from '@zooplus/commons-lang';
import { CarouselBeta, CarouselSlideBeta, H3 } from '@zooplus/ui-components';

import { useTranslation } from '../../hooks/use-translations';
import useMedias from '../../hooks/useMedias';
import { useMetrics } from '../../hooks/useMetrics';
import { InfoForExample } from '../../model/product';
import { CentralHubService } from '../../services/CentralHubService';

import { ExamplesCard } from './examples-card';
import styles from './Examples.module.scss';
import { ReactComponent as example1 } from './images/example1.svg';
import { ReactComponent as example2 } from './images/example2.svg';
import { ReactComponent as example3 } from './images/example3.svg';

export const Examples = () => {
  const { t } = useTranslation();
  const { isMobile, isSmallMobile } = useMedias();
  const images = [example1, example2, example3];

  const options: EmblaOptionsType = {
    align: 'center',
    breakpoints: {
      '(min-width: 0px)': {
        align: 'center',
        slidesToScroll: 1,
      },
      '(min-width: 544px)': {
        align: 'start',
        slidesToScroll: 2,
      },
    },
    slidesToScroll: 1,
  };

  const { site, language } = useSiteContext();
  const [examplesInfo, setExamplesInfo] = useState<InfoForExample[] | undefined>(undefined);

  const metrics = useMetrics('examples');

  useEffect(() => {
    metrics.renderInit();
  }, []);

  useEffect(() => {
    CentralHubService(undefined)
      .getInfoForExamplesSection(site.domain, language)
      .then((response) => {
        if (response) {
          setExamplesInfo(response);
        }
      })
      .catch(() => {
        metrics.renderError('EndpointError');
      });
  }, []);

  useEffect(() => {
    if (examplesInfo) {
      metrics.renderSuccess();
    }
  }, [examplesInfo]);

  return (
    <section>
      <H3 className={styles.title}>{t('examples.title')}</H3>
      {!isMobile && !isSmallMobile ? (
        <div className={styles.examplesOtherDevices}>
          {examplesInfo?.map((info, index) => (
            <ExamplesCard
              key={`example-${index}`}
              image={images[index]}
              exampleNumber={info.scenario}
              examplesInfo={info}
            />
          ))}
        </div>
      ) : (
        <div className={styles.examplesMobile}>
          <CarouselBeta
            id="savings-examples-carousel"
            emblaOptions={options}
            gap={'12px'}
            nextButtonAriaLabel="next"
            previousButtonAriaLabel="previous"
            className={styles.carousel}>
            {examplesInfo?.map((info, index) => (
              <CarouselSlideBeta className={styles.carouselItem} key={`example-slide-${index}`}>
                <ExamplesCard
                  key={`example-${index}`}
                  image={images[index]}
                  exampleNumber={info.scenario}
                  examplesInfo={info}
                />
              </CarouselSlideBeta>
            ))}
          </CarouselBeta>
        </div>
      )}
    </section>
  );
};
